import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';

export const TL_FUEL_URL = new InjectionToken<string>('TL_FUEL_URL');

export interface IIqTrendlinesFuelStateService {
    cost(): Signal<string>;
    percentChange(): Signal<string>;
    data(): Promise<{ perGallon: number; percentChange: number }>;
}

export type TrendlinesFuelResponse = {
    vanTrends: VanTrends;
    reeferTrends: ReeferTrends;
    flatbedTrends: FlatbedTrends;
    nationalTrends: NationalTrends;
};

export type VanTrends = {
    weekOverWeekVanLoadToTruckRatioChangeInPercentage: string | number;
    monthOverMonthVanLoadToTruckRatioChangeInPercentage: string | number;
    yearOverYearVanLoadToTruckRatioChangeInPercentage: string | number;
    weekOverWeekVanSpotRateChangeInPercentage: string | number;
    monthOverMonthVanSpotRateChangeInPercentage: string | number;
    yearOverYearVanSpotRateChangeInPercentage: string | number;
};
export type ReeferTrends = {
    weekOverWeekReeferLoadToTruckRatioChangeInPercentage: string | number;
    monthOverMonthReeferLoadToTruckRatioChangeInPercentage: string | number;
    yearOverYearReeferLoadToTruckRatioChangeInPercentage: string | number;
    weekOverWeekReeferSpotRateChangeInPercentage: string | number;
    monthOverMonthReeferSpotRateChangeInPercentage: string | number;
    yearOverYearReeferSpotRateChangeInPercentage: string | number;
};
export type FlatbedTrends = {
    weekOverWeekFlatbedLoadToTruckRatioChangeInPercentage: string | number;
    monthOverMonthFlatbedLoadToTruckRatioChangeInPercentage: string | number;
    yearOverYearFlatbedLoadToTruckRatioChangeInPercentage: string | number;
    weekOverWeekFlatbedSpotRateChangeInPercentage: string | number;
    monthOverMonthFlatbedSpotRateChangeInPercentage: string | number;
    yearOverYearFlatbedSpotRateChangeInPercentage: string | number;
};
export type NationalTrends = {
    weekOverWeekNationalLoadPostingsChangeInPercentage: string | number;
    weekOverWeekNationalTruckPostingsChangeInPercentage: string | number;
    monthOverMonthNationalLoadPostingsChangeInPercentage: string | number;
    monthOverMonthNationalTruckPostingsChangeInPercentage: string | number;
    yearOverYearNationalLoadPostingsChangeInPercentage: string | number;
    yearOverYearNationalTruckPostingsChangeInPercentage: string | number;
    weekOverWeekNationalFuelPriceChangeInPercentage: string | number;
    monthOverMonthNationalFuelPriceChangeInPercentage: string | number;
    yearOverYearNationalFuelPriceChangeInPercentage: string | number;
};
